import { createContext } from 'react'

const CollapsibleContext = createContext({})

export default CollapsibleContext
